const Title = ()=>
{
    return (
    <div className="title">
        <h2>experience</h2>
        <div className="underline"></div>
    </div>);
}

export default Title;